import { useEffect, useState, useRef } from "react";
import { useAppSelector } from "../../../reduxToolkit/hooks";
import { toast } from "react-toastify";
import { setLoginTime } from "../../../reduxToolkit/reducers/layout/authSlice";
import ApiService from "../../../services/apiService";
import { format } from 'date-fns'
import { useAppDispatch } from "../../../reduxToolkit/hooks";

export default function AlarmCheck() {

    let loginTime: null | string = useAppSelector((state) => state.auth.loginTime);
    const pollingRef = useRef<NodeJS.Timeout | null>(null)
    const loginRef = useRef<NodeJS.Timeout | string>(loginTime)
    const dispatch = useAppDispatch()

    useEffect(() => {
        loginRef.current = loginTime;
      }, [loginTime]);

    useEffect(() => {

        if (!loginTime) return;

        const alarm = async () => {

            try {
                const response = await ApiService.axiosApi(`/alarms/checkalarm`, {

                    method: 'GET',
                    params: {
                        loginTime: loginRef.current
                    }
                })

                if (response.success) {
                      
                    if (response.data[0].id === null) {
                         
                        // const nowtime = format(new Date(), 'yyyy-MM-dd HH:mm:ss')
                        // dispatch(setLoginTime(nowtime))
                         
                    } else {
                          
                        response.data.map((data: any) => (
                            toast.warn(`🔔 ${data.chakName}  Alarm:${data.alarm}`)
                        ))
                         loginRef.current = response.data[0].maxAlarmTime;
                        dispatch(setLoginTime(response.data[0].maxAlarmTime))
                        
                    }


                } else {
                    console.log("error:", response.message || response.status);

                }

            } catch (e) {
                console.log(e);
            }
        }

         pollingRef.current = setInterval(alarm, 5000); // poll every 5s
        // optional: call immediately
        alarm();

    return () => {
      if (pollingRef.current) {
        clearInterval(pollingRef.current);
        pollingRef.current = null;
      }
    };
    }, []);

    return null;
}